<template>
  <div class="NECMThingPage">
    <h5 class="title">请将提货卡出示给店员</h5>
    <div class="main">
      <div class="main_top">
        <div class="imgBox">
          <img src="./img/thing.png" alt="" class="img">
        </div>
        <div class="title">99元以内饰品随心选</div>
      </div>
      <div class="main_desc">
        <div class="text">使用说明：</div>
        <div class="text redDot">本提货卡需到店拍摄完成后出示给店员使用</div>
        <div class="text redDot">由于门店库存不确定性，您可到店根据门店伙伴指引任意挑选一样价值99元以内饰品</div>
      </div>
    </div>
    <img src="./img/bottom_logo.png" alt="" class="bottomlogo">
  </div>
</template>

<script>
export default {
  name: "NECMTHING",
};
</script>

<style scoped lang="less">
.NECMThingPage {
  box-sizing: border-box;
  min-height: 100vh;
  padding-top: 40px;
  background-color: #c90020;

  > .title {
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    color: #fff;
    text-align: center;
  }

  > .main {
    box-sizing: border-box;
    width: 335px;
    padding: 12px;
    margin: 28px auto 0;
    background: #fff;
    border-radius: 44px 12px 12px 12px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
  }

  .main_top {
    position: relative;
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    &::before {
      position: absolute;
      bottom: 0;
      left: 0;
      display: block;
      width: 400%;
      height: 1px;
      content: '';
      background-color: #ddd;
      transform: scale(0.25);
      transform-origin: left top;
    }

    .imgBox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 72px;
      height: 72px;
      background-color: #000;
      border-radius: 50%;

      .img {
        width: 43px;
        height: 36px;
      }
    }

    .title {
      margin-left: 13px;
      font-family: PingFang SC;
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      color: #262626;
    }
  }

  .main_desc {
    padding-top: 20px;

    .text {
      margin-bottom: 10px;
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 17px;
      color: #8c8c8c;
      letter-spacing: 0.2px;
    }

    .redDot {
      position: relative;
      padding-left: 10px;

      &::before {
        position: absolute;
        top: 6px;
        left: 0;
        display: block;
        width: 4px;
        height: 4px;
        content: '';
        background-color: #c90020;
        border-radius: 50%;
      }
    }
  }

  > .bottomlogo {
    position: absolute;
    bottom: 57px;
    left: 50%;
    width: 220px;
    height: 20px;
    transform: translateX(-50%);
  }
}
</style>
